import * as Yup from 'yup';

export const validationSchema = Yup.object({
    date: Yup.date().nullable().required('La date est obligatoire'),
    time: Yup.boolean().oneOf([true], 'Un créneau doit être sélectionné').required('Vous devez choisir un créneau horaire'),
});
